<div class="row justify-content-center">
  <div class="col-12 col-lg-10 col-xl-8">
    <h1>Questionnaire créé</h1>

    <div class="card">
      <div class="card-body">

        <!-- Heading -->
        <h3 class="card-title">{{ this.getClientName() }} <small>({{ this.getClientEmail() }})</small></h3>

        <!-- Text -->
        <div class="card-text mt-4">
          Envoyez le lien ci-dessous à votre client pour qu'il puisse remplir le questionnaire.
          <div class="input-group mb-3" style="max-width: 800px;">
            <input [value]="getLink()" aria-describedby="button-addon2" aria-label="Recipient's username"
              class="form-control" disabled placeholder="Recipient's username"
              readonly type="text">
            <button (click)="copyToClipboard()" class="btn btn-primary" id="button-addon2" type="button"><i
            class="far fa-copy"></i>
            Copier le lien
          </button>
        </div>
        @if (hasCopied) {
          <small class="text-success"><i class="fas fa-check"></i> Copié</small>
        }
      </div>

      <a [href]="mailtoLink()" class="btn btn-light mt-3"
        target="_blank"><i class="fas fa-paper-plane"></i> Envoyer par courriel</a>
        <a [routerLink]="'/client-questionnaires/' + this.clientQuestionnaireResponse?.keyname + '/' + this.clientQuestionnaireResponse?.id"
          class="ms-3 btn btn-link"><i class="fas fa-eye"></i> Visualiser le questionnaire</a>

        </div>
      </div>

      <!-- Button -->
      <a class="btn btn-primary" routerLink="/client-questionnaires/create">Créer un nouveau questionnaire</a>


    </div>
  </div> <!-- / .row -->